import {
    DEFAULT_MARGIN,
    MarginParams,
    useTickDatumGetterForDate,
} from '@/components/common/charts/chartHelper';
import { defaultChartTooltipWidth } from '@/components/common/charts/ChartTooltip';
import { useTodayX } from '@/components/common/charts/TodayLine';
import { useTickRangeNumericChartWithTooltip } from '@/components/common/charts/useTickRangeNumericChartWithTooltip';
import { TransactionsChartDatum } from '@common/react/cashflow';
import { TickRange, ValueSeries } from '@common/valueSeries';
import { useCallback } from 'react';

export const useTransactionsChart = ({
    valueSeries,
    width,
    height,
    range,
    min,
    max,
    xScaleType,
    margin = DEFAULT_MARGIN,
}: {
    valueSeries: ValueSeries<TransactionsChartDatum>;
    width: number;
    height: number;
    range: TickRange;
    min: number;
    max: number;
    xScaleType: 'band' | 'point';
    margin?: MarginParams;
}) => {
    const getDatumForDate = useTickDatumGetterForDate(
        valueSeries,
        (datum) => datum
    );

    const tooltipDataForDate = useCallback(
        (date: string) => getDatumForDate(date),
        [getDatumForDate]
    );

    // We don't use the tooltip Y position, so can just pass 0 here
    const maxValueForDate = useCallback(() => 0, []);

    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    const toolTipInfoAndScales = useTickRangeNumericChartWithTooltip({
        range,
        innerHeight,
        innerWidth,
        yScaleDomain: [min, max],
        xScaleType,
        tooltipDataForDate,
        maxValueForDate,
        margin,
        tooltipXBuffer: defaultChartTooltipWidth / 1.5,
    });

    const todayX = useTodayX({ range, xScale: toolTipInfoAndScales.xScale });

    return {
        innerWidth,
        innerHeight,
        todayX,
        ...toolTipInfoAndScales,
    };
};
